'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setCurrentTimeMs;

var _constants = require('../constants');

var _store = require('../../../store');

var _store2 = _interopRequireDefault(_store);

var _ = require('./');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setCurrentTimeMs(playerId, currentTimeMs) {
  return function (dispatch, getState) {
    var state = getState().players[playerId];
    if (!state) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Player doesn't exist");
      }
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (currentTimeMs < 0) {
        console.warn('Action:setCurrentTimeMs: The current time cannot be set to a time\n          before 0: currentTimeMs: ' + currentTimeMs);
      }
      if (currentTimeMs >= state.durationMs) {
        console.warn('Action:setCurrentTimeMs: The current time cannot be set to a time longer than the durationMs:\n          currentTimeMs: ' + currentTimeMs + '  durationMs: ' + state.durationMs);
      }
    }

    var isLooping = null;
    if (!state.seeking) {
      isLooping = state.loop.get('isLooping');
      if (isLooping && (currentTimeMs < state.loop.get('startTimeMs') || currentTimeMs > state.loop.get('endTimeMs'))) {
        isLooping = false;
      }
    }

    var player = _store2.default.getPlayerInstance(playerId);
    if (player) {
      player.currentTime = currentTimeMs / 1000;
    }
    // Adding currentTimeMs here purely for devtools to see what is being set
    dispatch({ type: _constants.SET_CURRENT_TIME_MS, currentTimeMs: currentTimeMs });
    dispatch((0, _.setQueueEnded)(playerId, false));
    if (isLooping) {
      var loop = state.loop;
      dispatch((0, _.setLooping)(playerId, {
        isLooping: isLooping,
        startTimeMs: loop.get('startTimeMs'),
        endTimeMs: loop.get('endTimeMs')
      }));
    }
  };
} /* eslint-disable no-console */
module.exports = exports['default'];